// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  //   Dialog,
  //   DialogContent,
  //   DialogActions,
  //   Divider,
  //   Container,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";
import AppConfig from "appConfig";

// import Editor from "react-simple-wysiwyg";

function ReportFilter() {
  const pageTitle = "Filter Reports";
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  // const { id } = useParams();

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [campaigns, setCampaigns] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [aggregators, setAggregators] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/reports/init.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);
            setAgentGroups(result.data.data.groups);
            setAggregators(result.data.data.aggregators);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function downloadReport(type) {
    const form = document.forms.sales_filter_form;
    const data = Object.fromEntries(new FormData(form).entries());
    // console.log(data);
    let campaignPresent = false;
    const queryObj = {};
    Object.keys(data).forEach((k) => {
      if (data[k] !== "") {
        queryObj[k] = data[k];
        if (k === "campaign") {
          campaignPresent = true;
        }
      }
    });

    if (campaignPresent === false) {
      setSeverity("error");
      setErrMsg("Please select a campaign.");
      setOpen(true);
      return;
    }

    const queryString = new URLSearchParams(queryObj).toString();
    if (type === "sales") {
      const downloadUrl = `${AppConfig.api_base_url}reports/sales/filter/${accountInfo.account.reference}/${accountInfo.user.reference}?${queryString}`;
      window.open(downloadUrl, "_blank");
    }

    if (type === "agents") {
      const downloadUrl = `${AppConfig.api_base_url}reports/sales/filter/agents/${accountInfo.account.reference}/${accountInfo.user.reference}?${queryString}`;
      window.open(downloadUrl, "_blank");
    }
  }

  function downloadDataReport(type) {
    const form = document.forms.data_filter_form;
    const data = Object.fromEntries(new FormData(form).entries());
    let campaignPresent = false;
    const queryObj = {};
    Object.keys(data).forEach((k) => {
      if (data[k] !== "") {
        queryObj[k] = data[k];
        if (k === "campaign") {
          campaignPresent = true;
        }
      }
    });

    if (campaignPresent === false) {
      setSeverity("error");
      setErrMsg("Please select a campaign.");
      setOpen(true);
      return;
    }

    const queryString = new URLSearchParams(queryObj).toString();
    if (type === "captures") {
      const downloadUrl = `${AppConfig.api_base_url}reports/data/filter/${accountInfo.account.reference}/${accountInfo.user.reference}?${queryString}`;
      window.open(downloadUrl, "_blank");
    }

    if (type === "agents") {
      const downloadUrl = `${AppConfig.api_base_url}reports/data/filter/agents/${accountInfo.account.reference}/${accountInfo.user.reference}?${queryString}`;
      window.open(downloadUrl, "_blank");
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={2} mb={3}>
        <MDBox pl={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Download Reports
          </MDTypography>
        </MDBox>
        <MDBox mt={3}>
          <MDBox>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium">
                    Sales
                  </MDTypography>
                  {/* <MDTypography variant="h6" fontWeight="light" align="right">
                          <a
                            href={`${AppConfig.api_base_url}accounts/reports/${accountInfo.account.reference}/${accountInfo.user.reference}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Icon sx={{ fontWeight: "bold" }}>download</Icon> &nbsp;Full Report
                          </a>
                        </MDTypography> */}
                  <MDButton
                    variant="outlined"
                    color="dark"
                    size="small"
                    onClick={() => {
                      const downloadUrl = `${AppConfig.api_base_url}accounts/reports/${accountInfo.account.reference}/${accountInfo.user.reference}`;
                      window.open(downloadUrl, "_blank");
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                    &nbsp;Full Report
                  </MDButton>
                </MDBox>
                <MDBox mt={3}>
                  <form id="sales_filter_form">
                    <MDBox>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Campaign</InputLabel>
                              <Select
                                name="campaign"
                                label="Campaign"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    campaigns.map((record) => {
                                      if (record.campaign_type === "SALES") {
                                        return (
                                          <MenuItem value={record.reference}>
                                            {record.title}
                                          </MenuItem>
                                        );
                                      }
                                      return null;
                                    })
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Agent Group</InputLabel>
                              <Select
                                name="group"
                                label="Agent Group"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    agentGroups.map((record) => (
                                      <MenuItem value={record.reference}>{record.title}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Supervisor</InputLabel>
                              <Select
                                name="aggregator"
                                label="Supervisor"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  aggregators.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    aggregators.map((record) => (
                                      <MenuItem value={record.reference}>{record.title}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={1}>
                            <MDInput
                              placeholder="Staff Number"
                              name="staff_number"
                              margin="dense"
                              label="Agent Staff Number"
                              type="text"
                              fullWidth
                              variant="outlined"
                            />
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={2}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox>
                            <MDInput
                              placeholder="Product"
                              name="product"
                              margin="dense"
                              label="Product"
                              type="text"
                              fullWidth
                              variant="outlined"
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox>
                            <MDInput
                              placeholder="Amount"
                              name="amount"
                              margin="dense"
                              label="Amount"
                              type="text"
                              fullWidth
                              variant="outlined"
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={1}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Payment Method</InputLabel>
                              <Select
                                name="payment_method"
                                label="Payment Method"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                <MenuItem value="CASH">Cash</MenuItem>
                                <MenuItem value="BANK">Bank Transfer</MenuItem>
                                <MenuItem value="CARD">Card</MenuItem>
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={1}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Transaction Status</InputLabel>
                              <Select
                                name="transaction_status"
                                label="Transaction Status"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value={null}>---</MenuItem>
                                <MenuItem value="success">Successful</MenuItem>
                                <MenuItem value="failed">Failed</MenuItem>
                                <MenuItem value="error">Error</MenuItem>
                                <MenuItem value="abandoned">Abandoned</MenuItem>
                                <MenuItem value="created">Pending</MenuItem>
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="date"
                              margin="dense"
                              label="Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="start_date"
                              margin="dense"
                              label="Start Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="end_date"
                              margin="dense"
                              label="End Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={3} align="right">
                      <MDButton
                        color="success"
                        variant="contained"
                        onClick={() => {
                          downloadReport("sales");
                        }}
                      >
                        <Icon>download</Icon> &nbsp; <Icon>list_alt</Icon>
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        color="dark"
                        variant="contained"
                        onClick={() => {
                          downloadReport("agents");
                        }}
                      >
                        <Icon>download</Icon> &nbsp; <Icon>support_agent</Icon>
                      </MDButton>
                    </MDBox>
                  </form>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium">
                    Data
                  </MDTypography>
                </MDBox>
                <MDBox mt={3}>
                  <form id="data_filter_form">
                    <MDBox>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Campaign</InputLabel>
                              <Select
                                name="campaign"
                                label="Campaign"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    campaigns.map((record) => {
                                      if (record.campaign_type === "DATA") {
                                        return (
                                          <MenuItem value={record.reference}>
                                            {record.title}
                                          </MenuItem>
                                        );
                                      }
                                      return null;
                                    })
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Agent Group</InputLabel>
                              <Select
                                name="group"
                                label="Agent Group"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    agentGroups.map((record) => (
                                      <MenuItem value={record.reference}>{record.title}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={2}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Supervisor</InputLabel>
                              <Select
                                name="aggregator"
                                label="Supervisor"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                              >
                                <MenuItem value="">---</MenuItem>
                                {
                                  // --> Notice below changes
                                  aggregators.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    aggregators.map((record) => (
                                      <MenuItem value={record.reference}>{record.title}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <MDBox mt={1}>
                            <MDInput
                              placeholder="Staff Number"
                              name="staff_number"
                              margin="dense"
                              label="Agent Staff Number"
                              type="text"
                              fullWidth
                              variant="outlined"
                            />
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="date"
                              margin="dense"
                              label="Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="start_date"
                              margin="dense"
                              label="Start Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox>
                            <MDInput
                              name="end_date"
                              margin="dense"
                              label="End Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={3} align="right">
                      <MDButton
                        color="info"
                        variant="contained"
                        onClick={() => {
                          downloadDataReport("captures");
                        }}
                      >
                        <Icon>download</Icon> &nbsp; <Icon>list</Icon>
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        color="dark"
                        variant="contained"
                        onClick={() => {
                          downloadDataReport("agents");
                        }}
                      >
                        <Icon>download</Icon> &nbsp; <Icon>support_agent</Icon>
                      </MDButton>
                    </MDBox>
                  </form>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ReportFilter;
